import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";
import type { TitleProps } from "./TitleProps";

const titles: Record<string, string> = {
  "/": "RenCamp | Plan the faire. Sleep nearby.",
  "/fests": "Fests | RenCamp",
  "/calendar": "Calendar | RenCamp",
  "/about": "About | RenCamp",
  "/contact": "Contact | RenCamp",
};

const Title: FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    document.title =
      titles[location.pathname] ?? "RenCamp | Plan the faire. Sleep nearby.";
  }, [location, title]);

  return null;
};

export default Title;
